import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { GET_TOTAL_REVENUE_BY_TYPE } from "../Schema/Dashboard";

const useGetTotalRevenueByType = ({ filterMonth }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_TOTAL_REVENUE_BY_TYPE, {
    variables: {
      filterMonth: moment(filterMonth).format("YYYY-MM-DD")
    },
    onCompleted: ({ getTotalRevenueByType }) => {
      // console.log("getTotalRevenueByType::", getTotalRevenueByType)
      setTableData(getTotalRevenueByType);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [filterMonth]);

  return { tableData, loading };
};

export default useGetTotalRevenueByType;
